import { FilterProps } from '@/components/Filter/types';

import { filterPaperStyles } from './styles';

export const MENU_LIST_OVERRIDES: FilterProps['overrides'] = {
  className: filterPaperStyles,
};
